{
  "tabs": {
    "chat": "Ìjíròrò",
    "reminders": "Ìrántí",
    "calendar": "Kálẹ́ńdà",
    "settings": "Ẹ̀tọ́"
  },
  "common": {
    "cancel": "Fagilé",
    "save": "Fipamọ́",
    "confirm": "Jẹ́rìí",
    "delete": "Pa",
    "back": "Padà",
    "close": "Tí",
    "edit": "Ṣàtúnṣe",
    "search": "Ṣàwárí",
    "all": "Gbogbo",
    "loading": "N ń rù...",
    "error": "Ohun kan ṣẹlẹ̀",
    "notFound": "Kò rí",
    "tryAgain": "Jọ̀wọ́ tún gbìmọ̀",
    "retry": "Tun gbìmọ̀",
    "undo": "Fagilé",
    "pullToRefresh": "Fa láti tún ṣe",
    "justNow": "ní báyìí"
  },
  "auth": {
    "welcome": "Ẹ káàbọ̀ sí FishMemory",
    "tagline": "Olùrànlọ́wọ́ ìrántí WhatsApp rẹ, ní báyìí nínú àpò rẹ.",
    "subtitle": "Olùrànlọ́wọ́ ìrántí WhatsApp rẹ, ní báyìí nínú àpò rẹ.",
    "phoneLabel": "Nọ́mbà WhatsApp rẹ",
    "phoneHint": "A máa rán kóòdù ìmúlò nípasẹ̀ WhatsApp",
    "invalidPhone": "Jọ̀wọ́ tẹ nọ́mbà tó wúlò",
    "continue": "Tẹ̀síwájú",
    "enterPhone": "Tẹ nọ́mbà WhatsApp rẹ",
    "phonePlaceholder": "Nọ́mbà fónù",
    "sendCode": "Rán Kóòdù",
    "verifyTitle": "Ṣàyẹ̀wò nọ́mbà rẹ",
    "otpSentTo": "Kóòdù dígìtì 6 ni a rán sí {{phone}} nípasẹ̀ WhatsApp",
    "enterFullCode": "Jọ̀wọ́ tẹ gbogbo dígìtì 6",
    "invalidOtp": "Kóòdù kò tọ́́. Jọ̀wọ́ tún gbìmọ̀.",
    "otpFailed": "Kò ríran kóòdù. Tún gbìmọ̀.",
    "otpResent": "Kóòdù tún rán",
    "resendIn": "Tún rán ní {{seconds}}s",
    "resendCode": "Tún rán kóòdù",
    "enterOtp": "Tẹ kóòdù tí a rán sí WhatsApp rẹ",
    "verify": "Ṣàyẹ̀wò",
    "resend": "Tún rán kóòdù",
    "wrongNumber": "Nọ́mbà tó ṣàṣìṣe?",
    "backToPhone": "Padà sí fónù",
    "editPhone": "Ṣàtúnṣe nọ́mbà fónù",
    "error": "Àṣìṣe",
    "setupTitle": "Ẹ jẹ́ ká ṣètò",
    "setupSubtitle": "O lè yí wọn padà lẹ́yìn nínú Ẹ̀tọ́",
    "namePlaceholder": "Orúkọ rẹ",
    "letsGo": "Parí ìṣètò",
    "skipForNow": "Fo fún báyìí"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Kọ ìránṣẹ́...",
    "inputPlaceholder": "Kọ ìránṣẹ́...",
    "typing": "FishMemory ń kọ...",
    "online": "Lórí Ayélujára",
    "connecting": "N ń so pọ̀...",
    "reconnecting": "N tún so pọ̀...",
    "offline": "Kò lórí Ayélujára",
    "empty": "Bẹrẹ ìjíròrò",
    "emptyHint": "Ṣẹda ìrántí, ṣàyẹ̀wò àtòjọ ìṣẹ̀lẹ̀ rẹ, tàbí béèrè fún ìrànlọ́wọ́.",
    "emptyAction": "Firanṣẹ́ àpẹẹrẹ ìrántí",
    "actions": "Ìṣe ìjíròrò",
    "keep": "Pa ìránṣẹ́ mọ́",
    "clearTitle": "Nu ìjíròrò",
    "clearConfirm": "Ṣé o fẹ́ pa gbogbo ìránṣẹ́ nínú ẹ̀rọ yìí? Kò lè yípadà.",
    "clear": "Nu ìjíròrò",
    "optionSelected": "Ti yan: {{label}}",
    "sendingSelection": "N rán...",
    "connectionLost": "N tún so pọ̀..."
  },
  "reminders": {
    "title": "Ìrántí Mi",
    "active": "Láàyè",
    "today": "Lónìí",
    "thisWeek": "Ọ̀sẹ̀ yìí",
    "history": "Ìtàn",
    "items": "nkan",
    "emptyTitle": "Kò sí ìrántí",
    "emptySubtitle": "Ṣẹda kan láti ìjíròrò, yóò hàn níbí.",
    "emptyAction": "Ṣí ìjíròrò",
    "filterActive": "Láàyè",
    "filterToday": "Lónìí",
    "filterWeek": "Ọ̀sẹ̀ yìí",
    "filterHistory": "Ìtàn",
    "emptyState": "Kò sí ìrántí. Bẹrẹ ìjíròrò!",
    "swipeDone": "Parí",
    "swipeSnooze": "Fagilé",
    "swipeDelete": "Pa",
    "search": "Ṣàwárí ìrántí...",
    "upcoming": "Tó ń bọ̀",
    "completed": "Tẹ́lẹ̀ parí",
    "overdue": "Tí kọjá àkókò",
    "tomorrow": "Ọ̀la",
    "synced": "Ti ṣàtúnṣe {{value}}",
    "swipeHint": "Fa ìrántí fún ìṣe míì",
    "noResults": "Kò sí ìrántí tó bá ìwádìí mu",
    "noResultsHint": "Tún gbìmọ̀ pẹ̀lú ọ̀rọ̀ míì tàbí nu ìwádìí",
    "deleteAllFailed": "Kò rí pa gbogbo ìrántí"
  },
  "calendar": {
    "title": "Kálẹ́ńdà",
    "today": "Lónìí",
    "tomorrow": "Ọ̀la",
    "completed": "parí",
    "noEvents": "Kò sí ìṣẹ̀lẹ̀",
    "noEventsSubtitle": "Yan ọjọ́ láti rí ìrántí àti ìṣẹ̀lẹ̀ kálẹ́ńdà.",
    "googleEvent": "Kálẹ́ńdà Google",
    "legendActive": "Láàyè",
    "legendRecurring": "Tún ń ṣẹlẹ̀",
    "legendDone": "Parí",
    "legendGoogle": "Google",
    "previousMonth": "Oṣù tó kọjá",
    "nextMonth": "Oṣù tó ń bọ̀",
    "previousYear": "Ọdún tó kọjá",
    "nextYear": "Ọdún tó ń bọ̀",
    "goToToday": "Lọ sí lónìí",
    "all": "Gbogbo",
    "active": "Láàyè",
    "done": "Parí",
    "paused": "Dákẹ́"
  },
  "settings": {
    "title": "Ẹ̀tọ́",
    "profile": "Àkọọlẹ",
    "name": "Orúkọ àfihàn",
    "enterName": "Tẹ orúkọ rẹ",
    "language": "Èdè",
    "uiLanguage": "Èdè àpẹrẹ",
    "uiLanguageHelp": "Yí UI app, àkọlé kálẹ́ńdà, àti ìtọsọ́nà àtẹ̀jáde lórí ẹ̀rọ yìí péré.",
    "serverLanguage": "Èdè ìjíròrò",
    "serverLanguageHelp": "Yí èdè tí server máa lò fún ìdáhùn àti ìrántí fún àkọọlẹ rẹ.",
    "timezone": "Àkókò àgbègbè",
    "currentTimezone": "Àkókò àgbègbè tó wà",
    "timezoneHelp": "Gbogbo àkókò ìrántí ni a fi àkókò yìí hàn.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Fipamọ́ àkókò",
    "timezoneSaved": "Àkókò ti yípadà",
    "detect": "Ṣàwárí",
    "detectFailed": "Kò rí àkókò àgbègbè",
    "autoDetect": "Ṣàwárí laifọwọyi láti GPS",
    "notifications": "Ìkìlọ̀",
    "notificationsHelp": "Ìrántí tó tẹ̀síwájú ń ṣàkóso ìkìlọ̀ tó tún ń ṣẹlẹ̀ lẹ́yìn ìrántí. Àṣẹ ìkìlọ̀ lórí ẹ̀rọ ni a ṣàkóso nínú ẹ̀rọ fónù rẹ.",
    "pushEnabled": "Ìkìlọ̀ Push",
    "autoDoneOnFire": "Samisi gẹ́gẹ́ bí parí nígbà tí a bá dá ìrántí lórí",
    "autoDoneOnFireDesc": "Tí kò bá ṣiṣẹ́, ìrántí máa wà láàyè títí o fi samisi gẹ́gẹ́ bí parí.",
    "googleCalendar": "Kálẹ́ńdà Google",
    "google": "Kálẹ́ńdà Google",
    "googleConnected": "Ti sopọ̀",
    "googleDisconnected": "Kò sopọ̀",
    "googleConnectedHelp": "Ìrántí tuntun lè ṣàtúnṣe sí kálẹ́ńdà rẹ laifọwọyi.",
    "googleDisconnectedHelp": "Sopọ̀ Kálẹ́ńdà Google láti jẹ́ kí ìrántí àti ìṣẹ̀lẹ̀ bá a lọ.",
    "googleConnectFailed": "Kò rí sopọ̀ Kálẹ́ńdà Google",
    "connected": "Ti sopọ̀",
    "disconnected": "Kò sopọ̀",
    "connect": "Sopọ̀",
    "disconnect": "Yọ asopọ̀",
    "autoSync": "Ṣàtúnṣe ìrántí tuntun laifọwọyi",
    "autosync": "Ṣàtúnṣe ìrántí tuntun laifọwọyi",
    "subscription": "Ìforúkọsílẹ̀",
    "trialUsed": "Ìdánwò: {{used}}/{{total}} ti lo",
    "trialStatus": "Ìdánwò wà",
    "activeStatus": "Ìforúkọsílẹ̀ láàyè",
    "expiredStatus": "Ìforúkọsílẹ̀ ti parí",
    "unsubscribedStatus": "Kò forúkọsílẹ̀",
    "about": "Nipa",
    "version": "Ẹya",
    "logout": "Jade",
    "logoutTitle": "Jade",
    "logoutConfirm": "Ṣé o dájú pé o fẹ́ jade?",
    "noName": "Kò sí orúkọ",
    "serverConnection": "Ìbáṣepọ̀ server",
    "serverUrl": "URL server",
    "serverEdit": "Ṣàtúnṣe",
    "saveReconnect": "Fipamọ́ kí o tún so pọ̀",
    "resetDefault": "Tún ṣe àtúnṣe àyẹ̀wò",
    "invalidServerUrlTitle": "URL server kò tọ́́",
    "invalidServerUrlMessage": "Tẹ URL server tó wúlò http tàbí https, fún àpẹẹrẹ https://example.com",
    "uiLanguageChangeFailed": "Kò rí yí èdè app. Jọ̀wọ́ tún gbìmọ̀.",
    "serverLanguageChangeFailed": "Kò rí yí èdè ìjíròrò. Jọ̀wọ́ tún gbìmọ̀.",
    "timezoneChangeFailed": "Kò rí yí àkókò àgbègbè. Jọ̀wọ́ tún gbìmọ̀.",
    "autoSyncChangeFailed": "Kò rí ṣe àtúnṣe auto-sync. Jọ̀wọ́ tún gbìmọ̀.",
    "nameChangeFailed": "Kò rí ṣe àtúnṣe orúkọ àfihàn. Jọ̀wọ́ tún gbìmọ̀.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Àlàyé ìrántí",
    "editTime": "Ṣàtúnṣe Àkókò",
    "rename": "Pèsè orúkọ tuntun",
    "snooze": "Fagilé",
    "snooze15": "Fagilé iṣẹju 15",
    "pause": "Dákẹ́",
    "pauseReminder": "Dákẹ́ ìrántí",
    "resume": "Tún bẹ̀rẹ̀",
    "resumeReminder": "Tún bẹ̀rẹ̀ ìrántí",
    "skip": "Fo Kẹ́yìn",
    "skipOccurrence": "Fo ìṣẹ̀lẹ̀ yìí",
    "syncGoogle": "Ṣàtúnṣe sí Google",
    "delete": "Pa",
    "deleteTitle": "Pa Ìrántí",
    "deleteConfirm": "Ìrántí yìí yóò parí pátápátá.",
    "deleteRecurringTitle": "Pa Ìrántí Tún ń ṣẹlẹ̀",
    "deleteRecurringMessage": "Ṣé o fẹ́ fo ìṣẹ̀lẹ̀ yìí tàbí pa gbogbo jara?",
    "deleteThisOccurrence": "Fo Ìṣẹ̀lẹ̀ yìí",
    "deleteEntireSeries": "Pa Gbogbo Jara",
    "done": "Parí",
    "markDone": "Samisi gẹ́gẹ́ bí parí",
    "undo": "Tun pada",
    "undoPrompt": "Ṣé o fẹ́ kí ó wà láàyè lẹ́ẹ̀kansi? Tun un ṣe báyìí.",
    "recurring": "Tún ń ṣẹlẹ̀",
    "nextRun": "Ìṣẹ̀lẹ̀ tó ń bọ̀",
    "oneTime": "Ìṣẹ̀lẹ̀ kan ṣoṣo",
    "pending": "Dúró de",
    "sent": "Ti rán",
    "paused": "Dákẹ́",
    "active": "Láàyè",
    "snoozed": "Fagilé",
    "localTime": "Hàn ní àkókò agbègbè rẹ",
    "recurrence": "Ìtẹ̀síwájú",
    "created": "Ṣẹda",
    "tags": "Àmì",
    "fireCount": "Ìgbà tí a ti dá",
    "actions": "Ìṣe",
    "none": "Kò sí",
    "snoozeFailed": "Kò rí fagilé ìrántí",
    "pauseFailed": "Kò rí dákẹ́ ìrántí",
    "resumeFailed": "Kò rí tún bẹ̀rẹ̀ ìrántí",
    "skipFailed": "Kò rí fo ìrántí",
    "doneFailed": "Kò rí samisi gẹ́gẹ́ bí parí",
    "undoFailed": "Kò rí tún ṣe ìpò ìrántí",
    "deleteFailed": "Kò rí pa ìrántí",
    "rescheduleTitle": "Ṣé o fẹ́ tún ṣe àtúnṣe?",
    "rescheduleMsg": "Ìrántí yìí ti kọjá àkókò. Ṣé o fẹ́ tún ṣe àtúnṣe rẹ?",
    "reschedule15": "Ní iṣẹju 15",
    "reschedule60": "Ní wákàtí 1",
    "keepOverdue": "Pa bí ó ṣe wà"
  },
  "onboarding": {
    "slide1Title": "Ẹ káàbọ̀ sí FishMemory",
    "slide1Sub": "Olùrànlọ́wọ́ ìrántí tirẹ — tí WhatsApp ń ṣiṣẹ́, tí a ṣe fún àpò rẹ.",
    "slide2Title": "Ṣe Ìjíròrò Bí Ó Ṣe Rẹ́",
    "slide2Sub": "Kọ ìrántí bí o ṣe ń rò: \"Rántí mi láti pè mámá ní ọ̀la ní ago mẹ́ta\" — a máa ṣe ìyókù.",
    "slide3Title": "Má Ṣe Ṣàì Rí Ohun Kankan",
    "slide3Sub": "Gba ìkìlọ̀ ní àkókò, ṣètò pẹ̀lú àmì, kí o sì máa tọ́jú ohun gbogbo tó ṣe pàtàkì.",
    "getStarted": "Bẹrẹ",
    "next": "Tẹ̀síwájú",
    "firstReminderTitle": "Ṣẹda ìrántí àkọ́kọ́ rẹ!",
    "firstReminderHint": "Gbìmọ̀ bẹ́ẹ̀:",
    "firstReminderExample": "Rántí mi láti mu omi ní ọ̀la ní ago mẹ́sàn-án",
    "gotIt": "Mo mọ̀!",
    "notifRationaleTitle": "Dúró Ní Àkókò",
    "notifRationaleBody": "FishMemory nílò ìkìlọ̀ láti rántí rẹ ní àkókò. Ìkìlọ̀ yóò jẹ́ fún ìrántí tí o ṣẹda nìkan.",
    "notifRationaleAllow": "Ṣí ìkìlọ̀",
    "notifRationaleLater": "Bóyá Lẹ́yìnna",
    "swipeHint": "Fa sẹ́hìn fún ìṣe kíákíá →",
    "calendarDragHint": "Fa láti gbooro ↕"
  }
}
